import axios from "axios";

const loadScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};

export const onSubmit = async (data, history) => {
    try {
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
            console.log("Razorpay SDK failed to load. Are you online?");
            return;
        }

        if (!data.isRecurringPayment) {
            // creating a new order
            const result = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/razorpay/order/standard`,
                { amount: data.amount }
            );

            if (!result) {
                console.log("Server error. Are you online?");
                return;
            }
            console.log(result, process.env.REACT_APP_BACKEND_URL);

            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY,
                amount: data.amount * 100, // 2000 paise = INR 20, amount in paisa
                name: data.name,
                description: data.cause,
                order_id: result.data,
                handler: function (response) {
                    history.push(
                        `/payment-success/${response.razorpay_payment_id}?name=${data.name}&amount=${data.amount}`
                    );
                },

                prefill: {
                    name: data.name,
                    email: data.email,
                    contact: data.phone,
                },
                notes: {
                    name: data.name,
                    addressLineOne: data.addressLineOne,
                    addressLineTwo: data.addressLineTwo,
                    city: data.city,
                    state: data.state,
                    pincode: data.pincode,
                    dateOfBirth: data.dateOfBirth,
                    referer: data.referenceCode,
                    cause: data.cause,
                    pancard: data.pancard,
                    taxExemption: data.taxExemption,
                    phone: data.phone,
                },
                theme: {
                    color: "#ea4633",
                },
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
            return;
        } else {
            // creating a new subscription
            const result = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/razorpay/order/standard`,
                {
                    email: data.email,
                    numberOfKids: data.numberOfKids,
                    numberOfMonths: data.numberOfMonths,
                }
            );

            if (!result) {
                console.log("Server error. Are you online?");
                return;
            }

            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY,
                name: data.name,
                description: data.cause,
                subscription_id: result.data,
                handler: function (response) {
                    history.push(
                        `/payment-success/${response.razorpay_payment_id}?name=${data.name}&amount=${data.amount}`
                    );
                },

                prefill: {
                    name: data.name,
                    email: data.email,
                    contact: data.phone,
                },
                notes: {
                    name: data.name,
                    addressLineOne: data.addressLineOne,
                    addressLineTwo: data.addressLineTwo,
                    city: data.city,
                    state: data.state,
                    pincode: data.pincode,
                    dateOfBirth: data.dateOfBirth,
                    referer: data.referenceCode,
                    cause: data.cause,
                    pancard: data.pancard,
                    taxExemption: data.taxExemption,
                    phone: data.phone,
                },
                theme: {
                    color: "#ea4633",
                },
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        }
    } catch (error) {
        console.log(error);
    }
};
